import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ArrayUtil, DateUtil, MathUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';

@Component({
  selector: 'app-billpay-receivable-provider',
  templateUrl: './billpay-receivable-provider.component.html',
  styleUrls: ['./billpay-receivable-provider.component.scss']
})
export class BillpayReceivableProviderComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  category = null;
  loadingChart = true;
  results = [];

  constructor(
    private toastService: ToastrService,
    private reportService: AccountingReportService
  ) {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.updateChart();
  }


  updateChart() {
    this.loadingChart = true;
    document.getElementById("billpay-receivable-provider")['innerHTML'] = "";
    this.reportService.getBillPayReceivableAndProviders(
      DateUtil.parseDateToMilliseconds(this.start),
      DateUtil.parseDateToMilliseconds(this.end)
    ).subscribe({
      next: (response: ResponseObject) => {
        this.loadingChart = false;
        this.results = response.data;
        var data = [];
        response.data.forEach((r) => {
          data.push({
            name: "Total",
            data: [r.totalBillReceivable ? r.totalBillReceivable : 0]
          })
          data[0].data.push(r.totalBillPay ? r.totalBillPay : 0);
          data[0].data.push(r.totalProvider ? r.totalProvider : 0);
        });

        var options = {
          series: data,
          chart: {
            height: 350,
            type: 'bar',
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              dataLabels: {
                position: 'top', // top, center, bottom
              },
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            }
          },

          xaxis: {
            categories: ["Cuentas por Cobrar", "Cuentas por Pagar", "Proveedores"],
            position: 'bottom',
            crosshairs: {
              fill: {
                type: 'gradient',
                gradient: {
                  colorFrom: '#D8E3F0',
                  colorTo: '#BED1E6',
                  stops: [0, 100],
                  opacityFrom: 0.4,
                  opacityTo: 0.5,
                }
              }
            },
            tooltip: {
              enabled: true,
            }
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return MathUtil.formatCurrency(val);
              }
            }

          }
        };

        var chart = new ApexCharts(document.querySelector("#billpay-receivable-provider"), options);
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.loadingChart = false;
      }
    })
  }
}
